<button mat-button [matMenuTriggerFor]="columns">
  <mat-icon>more_vert</mat-icon>
</button>
@if (['order', 'quote'].includes(entCode)) {
  <mat-form-field class="full-width">
    <mat-label>{{ 'QuoteConfigurator.totalDiscount' | translate }}</mat-label>
    <input
      matInput
      [(ngModel)]="totalDiscount"
      type="number"
      (ngModelChange)="changeTotalDisc()"
      [disabled]="disabled"
    />
    <mat-icon matSuffix>percent</mat-icon>
  </mat-form-field>
}
<mat-form-field class="full-width">
  <mat-label>{{ 'ERPWarehouse.warehouse' | translate }}</mat-label>
  <mat-select
    [(ngModel)]="defaultWarehouseId"
    (ngModelChange)="changeDefaultWarehouse()"
    [disabled]="disabled || warehouses().length === 0"
    [panelWidth]="null"
  >
    @for (warehouse of warehouses(); track warehouse.id) {
      <mat-option [value]="+warehouse?.id">
        {{ warehouse.id }} - {{ warehouse.title }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-menu #columns="matMenu">
  <button mat-menu-item (click)="onExportToExcel()">
    {{ 'Generic.export' | translate }}
  </button>
  <mat-selection-list
    [ngModel]="selectedColumns"
    (ngModelChange)="updateSelectedColumns($event)"
    style="max-height: 70vh"
  >
    @for (column of gridCols; track column.key) {
      <mat-list-option
        color="primary"
        [value]="column.key"
        (click)="$event.stopPropagation()"
      >
        {{ column.desc }}
      </mat-list-option>
    }

    <mat-divider></mat-divider>
    <div mat-subheader>{{ 'QuoteConfigurator.product' | translate }}</div>
    <mat-divider></mat-divider>
    @for (prodFld of product_fields; track prodFld.fld_code) {
      <mat-list-option
        color="primary"
        [value]="prodFld.fld_code"
        (click)="$event.stopPropagation()"
      >
        {{ prodFld | translateFieldLabel }}
      </mat-list-option>
    }
  </mat-selection-list>
</mat-menu>
